import { ArrowLeft } from "lucide-react"
import type { MouseEventHandler, ReactNode } from "react"
import { Link } from "react-router-dom"

interface Props {
  to: string
  children: ReactNode
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

/**
 * The "Volver a …" line above a page title.
 *
 * Two pages drew it two ways — a 16px-tall chevron link on the roster, a
 * 44px arrow button on the material — so the target a professor got depended
 * on the route (PRD-59 Etapa A). One shape: a real link, 44px on a phone,
 * 32px on desktop.
 */
export function BackLink({ to, children, onClick }: Props) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className="text-ink-muted hover:text-ink inline-flex min-h-11 items-center gap-1 text-xs font-medium md:min-h-8"
    >
      <ArrowLeft className="h-3.5 w-3.5" aria-hidden />
      {children}
    </Link>
  )
}
